<template>
    <div class="vehicle vehicle-card-car-camp d-flex" v-if="currentVehicle">
        <div class="car-camp-hero">
            <img class="car-camp-logo" src="/images/car-camp/car_camp_logo.png" alt="Car and camp" />
            <div
                :class="['vehicle-img-wrapper expanded', { 'col-4 p-1': cardType === 'us-source-booking' }]"
                :style="cardType === 'us-source-booking' ? 'background-image:url(' + imageUrl(currentVehicle.image) + ')' : ''"
                v-if="currentVehicle.image"
            >
                <div class="vehicle-image-overlay d-block d-lg-none expanded"></div>
                <img class="vehicle-image vehicle-fixed-height expanded" :src="imageUrl(currentVehicle.image)" :alt="currentVehicle.name" @error="imageLoadFailed(currentVehicle.image)" />
                <img class="loyalty-medal" :src="userLoyalty.image" :alt="userLoyalty.name" v-if="loyaltyDiscountApplied" />
            </div>
        </div>
        <vehicle-visual-summary :vehicle="vehicle" :labels="labels" :currentVehicle="currentVehicle" :currencyIsChanging="currencyIsChanging" :activeProduct="activeProduct" :experiment="experiment"></vehicle-visual-summary>
        <div class="car-camp-details-block">
        <div class="car-camp-middle-wrapper">
            <img class="car-camp-logo" src="/images/car-camp/car_camp_logo.png" alt="Car and camp" />
            <div class="car-camp-item-wrapper">
                <div>
                <img src="/images/svgs/GM_Car_&_Camp_Tent_&_Equipment.svg" :alt="$t('bookings.car_and_camp.tent_and_equipment')" />
                <span>{{ $t('bookings.car_and_camp.tent_and_equipment') }}</span>
                </div>
                <div>
                <img src="/images/svgs/GM_Car_&_Camp_Quick_&_Easy.svg" :alt="$t('bookings.car_and_camp.quick_and_easy')" />
                <span>{{ $t('bookings.car_and_camp.quick_and_easy') }}</span>
                </div>
                <div>
                <img src="/images/svgs/GM_Car_&_Camp_Travel_Freedom.svg" :alt="$t('bookings.car_and_camp.travel_freedom')" />
                <span>{{ $t('bookings.car_and_camp.travel_freedom') }}</span>
                </div>
                <div class="d-lg-none">
                    <img src="/images/svgs/GM_Car_&_Camp_Affordable.svg" :alt="$t('bookings.car_and_camp.affordable_campervan_alternative')" />
                    <span>{{ $t('bookings.car_and_camp.affordable_campervan_alternative') }}</span>
                </div>
                <div class="d-lg-none">
                    <img src="/images/svgs/GM_Lightweight_Compact.png" :alt="$t('bookings.car_and_camp.lightweight_and_compact')" />
                    <span>{{ $t('bookings.car_and_camp.lightweight_and_compact') }}</span>
                </div>
                <div class="d-lg-none">
                    <img src="/images/svgs/GM_Car_&_Camp_Fully_Insured_Green.svg" :alt="$t('bookings.car_and_camp.fully_insured')" />
                    <span>{{ $t('bookings.car_and_camp.fully_insured') }}</span>
                </div>
            </div>
        </div>

        <div class="price-block-mobile">
            <!-- <div class="upgrade-product" @click="openSheet">
                <span>{{ $t('bookings.drive_and_go.premium_plus_benefits_also_included') }}</span>
                <span class="upgrade-product-arrow" :class="{'active': shouldShowDetails}"></span>
            </div> -->

            <div class="foot">          
                <button class="link" @click="openSheet">{{ $t('bookings.drive_and_go.premium_plus_benefits_also_included') }}</button>        
            </div>

            <div class="mb-0 ml-4 w-100" v-if="shouldShowDetails">
                <product-details
                    :show-terms-and-conditions="showTermsAndConditions"
                    :product="activeProduct"
                    :currency-is-changing="currencyIsChanging"
                    upsell-card-type="mobile-us-product-upsell"
                    :experiment="experiment"
                ></product-details>
            </div>

            <div class="book-default w-100">
                <div class="camp-price">
                    <span class="was" v-if="activeProduct.original_price && !currencyIsChanging">{{ originalPrice(activeProduct) }}</span>
                    <span class="amount" v-if="currencyIsChanging">&hellip;</span>            
                    <span class="now" v-else>{{ vehiclePrice }}</span>            
                    <span class="per">{{ labels.extraPerDay }}</span>            
                    <span class="total">{{ price(activeProduct) }} {{ labels.total }}</span>          
                </div>

                <gm-button
                    @click="selectVehicleHandler(vehicle, activeProduct.id);"
                    v-if="vehicle.is_drive_and_go && activeProduct.is_available"
                    type="select"
                    :mobile-classes="true"
                    :disabled="disabledButtonStatus"
                >
                    {{ $t('bookings.book_now') }}
                </gm-button>
                <gm-button
                    top-right-radius="0"
                    top-left-radius="0"
                    :disabled="true"
                    :mobile-classes="true"
                    v-if="!activeProduct.is_available"
                >
                    {{ $t('VehicleCard.age_limit', { age: activeProduct.minimum_age }) }}
                </gm-button>
                
                    
                <div class="scrim" v-if="shouldShowSheet" data-close></div>        

                <transition name="slide-up">
                    <div class="vehicle-sheet sheet-wrap show" v-if="shouldShowSheet">            
                        <div class="sheet" role="dialog" aria-modal="true" aria-label="What's included and how it works">          
                            <h4>{{ $t('bookings.drive_and_go.premium_plus_benefits_also_included') }}</h4>          
                            <product-details
                                :show-terms-and-conditions="showTermsAndConditions"
                                :product="activeProduct"
                                :currency-is-changing="currencyIsChanging"
                                upsell-card-type="mobile-us-product-upsell"
                                :experiment="experiment"
                            ></product-details>  
                            <button class="close" data-close @click="openSheet">Close</button>        
                        </div>
                    </div>
                </transition>
            </div>
        </div>
        <price-card
            :class="{ active: true }"
            :key="activeProduct.type"
            :product="activeProduct"
            :vehicle="currentVehicle"
            :labels="labels"
            :buy="buy"
            :show-terms-and-conditions="showTermsAndConditions"
            :currency-is-changing="currencyIsChanging"
            :select-vehicle="selectVehicleHandler"
            :selected-currency="selectedCurrency"
            :user="user"
            :handle-login="handleLogin"
            :experiment="experiment"
        ></price-card>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import PriceCard from './PriceCard';
import Button from '../shared/Button';
import Accounting from '../../mixins/accounting';
import ImageUrlFallback from '../../mixins/imageUrlFallback';
import VehicleVisualSummary from './VehicleVisualSummary';
import VehicleCardLocalisations from '../../lang/VehicleCard';
import BookingsLocalisations from '../../lang/bookings';
import merge from 'lodash/merge';
import ProductDetails from './ProductDetails';
import branding from '../../mixins/branding';

export default {
    name: 'vehicle-card-car-camp',

    components: {
        'gm-button': Button,
        PriceCard,
        VehicleVisualSummary,
        ProductDetails,
    },

    mixins: [Accounting, ImageUrlFallback, branding],

    props: ['vehicle', 'buy', 'labels', 'locale', 'selectVehicle', 'showTermsAndConditions', 'handleLogin', 'experiment'],

    i18n: merge(VehicleCardLocalisations, BookingsLocalisations),
    data() {
        return {
            currencyIsChanging: false,
            disabledButtonStatus: false,
            imageErrorUrls: [],
            currentVehicle: null,
            product: null,
            showKeylessBenefits: false,
            products: [],
            shouldShowSheet: false,
            shouldShowDetails: false,
            icons: {
                PMP: this.brandingImagesPath('/images/vehicle-listing/premium-plus-badge.svg'),
            },
            productLabels: {
                PMP: 'premium plus+',
            },
            vehiclePricePerDay: 0,
        };
    },

    mounted() {
        this.currentVehicle = this.vehicle;
        window.bus.$on('currency.changed', this.currencyChanging);
        window.bus.$on('vehicle.selected', this.disableButton);
        window.bus.$on('toggle-drige-go-details', this.toggleDetails);
    },

    beforeDestroy() {
        window.bus.$off('currency.changed', this.currencyChanging);
    },

    watch: {
        vehicle: function (vehicle) {
            this.currencyIsChanging = false;
        },
        quoteHireDuration: function (duration) {
            this.vehiclePricePerDay = this.originalPricePerDay(this.activeProduct, duration);
        },
    },

    computed: Object.assign(
        {
            vehiclePrice() {
                return this.quoteHireDuration > 1 ? this.originalPricePerDay(this.activeProduct, this.quoteHireDuration) : this.formatMoney(this.activeProduct.total_price, this.selectedCurrency.code);
            },
            activeProduct() {
                const activeProducts = this.vehicle.products.data.filter((product) => product.type === 'PMP');
                return activeProducts.length > 0 ? activeProducts[0] : {};
            },
            pluralizationEnabled() {
                return !['tr'].includes(this.locale);
            },
            userLoyalty() {
                if (!this.user) {
                    return null;
                }

                const data = this.user.loyalty_level.data;

                return {
                    name: data.name,
                    image: this.brandingImagesPath(`/images/loyalty-icons/medals/${data.slug}.svg`),
                };
            },
            loyaltyDiscountApplied() {
                return this.vehicle.loyalty_discount_applied && this.userLoyalty;
            },
            pickupLocationIsUK() {
                return this.pickupLocation.country && this.pickupLocation.country.data.id === 1;
            },
        },
        mapGetters({
            quotePaymentType: 'quotePaymentType',
            quoteHireDuration: 'quoteHireDuration',
            selectedCurrency: 'selectedCurrency',
            user: 'getQuoteUser',
            quote: 'getQuote',
            pickupLocation: 'getPickupLocation',
        })
    ),

    methods: {
        currencyChanging() {
            this.currencyIsChanging = true;
        },
        setActiveProduct(vehicle, product) {
            this.products = this.products.map((aProduct) => {
                aProduct.active = false;
                return aProduct;
            });
            product.active = true;
        },
        showBenefits() {
            this.showKeylessBenefits = !this.showKeylessBenefits;
        },
        disableButton() {
            this.disabledButtonStatus = true;
        },
        selectVehicleHandler(vehicle, activeProductId) {
            window.bus.$emit('vehicle.selected');
            window.bus.$emit('vehicle.selecting');
            this.selectVehicle(vehicle, activeProductId);
        },
        openSheet() {
            this.shouldShowSheet = !this.shouldShowSheet;
        },
        toggleDetails() {
            this.shouldShowDetails = !this.shouldShowDetails;
        },
    },
};
</script>

<style lang="scss" src="./scss/vehicle-card.scss"></style>
<style lang="scss" src="./scss/vehicle-card-car-camp.scss"></style>
